import {
  TOGGLE_VIDEO_SOUND,
} from '../actions';

const initialState = {
  muted: true,
};

const audio = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_VIDEO_SOUND:
      return {
        ...state,
        muted: action.payload.muted,
      };

    default:
      return state;
  }
};

export default audio;
